import { render } from "./Crafts.vue?vue&type=template&id=27e70dee&scoped=true"
import script from "./Crafts.vue?vue&type=script&lang=js"
export * from "./Crafts.vue?vue&type=script&lang=js"

import "./Crafts.vue?vue&type=style&index=0&id=27e70dee&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-27e70dee"

export default script